import { axios } from "../../../../../../Global";
import { setAppError } from "../../../../../../store/userSlice";

const token = localStorage.getItem("token");

export const handleAddNewVendorSubmit = (
  e,
  selectedVendor,
  projectId,
  setAgencyData,
  recAgencyData,
  setSubmitLoading,
  dispatch,
  onToggle
) => {
  e.preventDefault();
  setSubmitLoading(true);
  const body = {
    vendor_id: selectedVendor,
  };
  axios
    .post("/dashboard/project-recruitment-agency-assign/" + projectId, body, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      setSubmitLoading(false);
      setAgencyData(res.data?.data);
      dispatch(setAppError({ msg: res.data.message, color: "success" }));
      onToggle();
    })
    .catch((error) => {
      setSubmitLoading(false);
      dispatch(
        setAppError({ msg: error?.response?.data?.message || error?.message })
      );
      onToggle();
    });
};

export const handleJEAssign = (jeRecruitmentAgencyId, selectedJobEnquiry) => {
  const body = {
    project_job_enquiry_id: selectedJobEnquiry,
  };
  return axios.put(
    `/dashboard/project-recruitment-agency-job-enquiry-assign/${jeRecruitmentAgencyId}`,
    body,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

export const fetchJobEnquiry = (
  jobEnquiryId,
  setInitialState,
  setOptionArrays,
  setDataLoading,
  dispatch
) => {
  try {
    axios
      .get(`/dashboard/project-job-enquiry/${jobEnquiryId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setDataLoading(false);
        setOptionArrays(response.data.data);
        setInitialState(response.data.data.job_enquiry);
      })
      .catch((error) => {
        setDataLoading(false);
        dispatch(
          setAppError({
            msg: error?.response?.data?.message || error?.message,
          })
        );
      });
  } catch (error) {
    setDataLoading(false);

    dispatch(
      setAppError({ msg: error?.response?.data?.message || error?.message })
    );
  }
};

export const postJobOrderCreate = (
  body,
  setAgencyData,
  setSubmitLoading,
  dispatch,
  setShowPromptElement
) => {
  setSubmitLoading(true);

  try {
    axios
      .post(`/dashboard/project-job-order-create`, body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setAgencyData(response.data?.data);
        dispatch(setAppError({ msg: response.data.message, color: "success" }));
        setSubmitLoading(false);
        setShowPromptElement((p) => ({ open: false }));
      })
      .catch((error) => {
        setSubmitLoading(false);
        dispatch(
          setAppError({
            msg: error?.response?.data?.message || error?.message,
          })
        );
        setShowPromptElement((p) => ({ open: false }));
      });
  } catch (error) {
    setSubmitLoading(false);

    dispatch(
      setAppError({ msg: error?.response?.data?.message || error?.message })
    );
  }
};

export function getInitialCostSheet(initialState) {
  const {
    project_job_enquiry_cost_sheet_cost_detail = [],
    project_job_enquiry_cost_sheet_heading = [],
    project_job_enquiry_cost_sheet_profession_basic_information = [],
  } = initialState;
  return project_job_enquiry_cost_sheet_profession_basic_information?.map(
    (data) => {
      const firstSectionCols = [];
      const rowEndColumns = [];
      // if (projectDetails?.quotation_type?.name != "Cost Plus") {
      project_job_enquiry_cost_sheet_heading?.forEach((headingData) => {
        const columnName =
          headingData?.rate_category_item_name ||
          headingData?.rate_category_item?.name ||
          headingData?.heading_name;

        const cost = getColumnCost(
          project_job_enquiry_cost_sheet_cost_detail,
          data,
          headingData
        );
        const returnObj = getColumnObj(headingData, columnName, cost);
        if (columnName == "VBenefit (SAR)" || columnName == "EDOC") {
          rowEndColumns.push({ ...returnObj, disabled: false });
        } else {
          firstSectionCols.push(returnObj);
        }
      });
      return setAllRowsData(data, [...firstSectionCols, ...rowEndColumns]);
    }
  );
}

function getColumnCost(
  project_job_enquiry_cost_sheet_cost_detail,
  data,
  headingData
) {
  return project_job_enquiry_cost_sheet_cost_detail
    ?.filter(
      (costData) =>
        costData?.project_job_enquiry_cost_sheet_profession_basic_information_id ==
        data?.id
    )
    .find(
      (costData) =>
        costData?.project_job_enquiry_cost_sheet_heading_id == headingData?.id
    )?.cost;
}

function getColumnObj(headingData, columnName, cost) {
  return {
    id: headingData?.id,
    rate_category_id: headingData?.rate_category_id || 1,
    rate_category_item_id: headingData?.id,
    rate_category_item_name: columnName,
    // type: headingData?.type,
    cost: cost,
    title: columnName,
    default: true,
    disabled: true,
  };
}

function setAllRowsData(data, firstSectionCols) {
  return {
    id: data?.id,
    job_position_id: data?.job_position_id,
    visa_profession_id: data?.visa_profession_id,
    profession_level_id: data?.profession_level_id,
    gender: data?.gender,
    nationality_id: data?.nationality_id,
    quantity: data?.quantity,
    sections: [
      {
        rate_category_id: 1,
        columns: firstSectionCols,
      },
    ],
  };
}
